import { render, staticRenderFns } from "./DatePeriod.vue?vue&type=template&id=b08ece90&scoped=true&"
import script from "./DatePeriod.vue?vue&type=script&lang=js&"
export * from "./DatePeriod.vue?vue&type=script&lang=js&"
import style0 from "./DatePeriod.vue?vue&type=style&index=0&id=b08ece90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08ece90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDatePicker,VFlex,VLayout,VMenu,VTextField})
